import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Send, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { SendingStatus } from '../types';

interface SendStatusButtonProps {
  status: SendingStatus;
  onSend: () => void;
  disabled: boolean;
  requiresResearch?: boolean;
}

export const SendStatusButton: React.FC<SendStatusButtonProps> = ({
  status,
  onSend,
  disabled,
  requiresResearch
}) => {
  const buttonConfig = {
    pending: {
      variant: 'default' as const,
      icon: Send,
      text: requiresResearch ? 'Ready to Notify' : 'Send'
    },
    loading: {
      variant: 'default' as const,
      icon: Loader2,
      text: requiresResearch ? 'Submitting...' : 'Sending...'
    },
    success: { variant: 'ghost' as const, icon: null, text: 'Sent' },
    error: { variant: 'default' as const, icon: null, text: 'Retry' },
    blocked: { variant: 'secondary' as const, icon: null, text: 'Blocked' }
  };

  const config =
    buttonConfig[status as keyof typeof buttonConfig] || buttonConfig.pending;
  const Icon = config.icon;

  return (
    <Button
      size="xs"
      density="compact"
      variant={config.variant}
      onClick={onSend}
      disabled={disabled || status === 'success' || status === 'loading'}
    >
      {Icon && (
        <Icon
          className={cn('mr-1 h-3 w-3', status === 'loading' && 'animate-spin')}
        />
      )}
      {config.text}
    </Button>
  );
};
